export default function renderChildren({children}) {

  return (
    <div className="back">
      {children}
    </div>
  )
}